/* eslint no-console: ["error", { allow: ["error"] }] */
import GeoJSON from "geojson";
import { mappingApi } from "@iventis/api/src/api";

export const getMapBoundingBoxPolygon = async (mapId: string, level: number | string, includeHiddenLayers = false) =>
    (await mappingApi.get<GeoJSON.Polygon>(`/maps/${mapId}/bounding-box?level=${level}&includeHiddenLayers=${includeHiddenLayers}`)).data;
